import React, { useEffect, useMemo, useRef } from 'react'
import * as THREE from 'three'
import { useResource } from 'react-three-fiber'
import { Text, Box, Octahedron, Plane } from '@react-three/drei'
import { Physics, useBox, usePlane } from '@react-three/cannon'

import useSlerp from './use-slerp'
import useRenderTarget from './use-render-target'
import useLayers from './use-layers'

if(window.lastStep==="right"){
    window.var_BG_COLOR = '#004bc8';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#1f93ff";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#004bc8";
    window.var_TEXT_VAR = "You're already listenin'!";
    window.var_LONG_TEXT_1 = "It looks like you're already doing the necessary steps towards";
    window.var_LONG_TEXT_2 = "a healthy, soulful, and greener lifestyle. Right on!";
    window.var_LONG_TEXT_3 = "";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="soul"){
    window.var_BG_COLOR = '#004bc8';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#1f93ff";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#004bc8";
    window.var_TEXT_VAR = "Your soul's callin'!";
    window.var_LONG_TEXT_1 = "Pay attention to your inner-self, and try to make some space for your soul.";
    window.var_LONG_TEXT_2 = "You'll be surprised to see how easier and simpler life can be if you see things";
    window.var_LONG_TEXT_3 = "from a spiritual perspective. The answer is in you, all you have to do is ask.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="body"){
    window.var_BG_COLOR = '#991d00';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#ff5746";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#991d00";
    window.var_TEXT_VAR = "Your body's callin'!";
    window.var_LONG_TEXT_1 = "Take care of your body and listen to it. Having respect for yourself physically is";
    window.var_LONG_TEXT_2 = "the main foundation in order to stay healthy and live a happier life. This is important";
    window.var_LONG_TEXT_3 = "not only for you, but also for your beloved ones and those who care about you.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="planet"){
    window.var_BG_COLOR = '#166f00';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#34ad09";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#166f00";
    window.var_TEXT_VAR = "Your planet's callin'!";
    window.var_LONG_TEXT_1 = "Being thankful for having the chance to live on such a beautiful planet is what you";
    window.var_LONG_TEXT_2 = "need the most at this moment. Earth takes care of you and other people, by offering";
    window.var_LONG_TEXT_3 = "vital conditions to live a free and happy life filled with fascinating experiences.";
    window.var_LONG_TEXT_4 = "Let's take care of our planet, she deserves it.";
}

if(window.lastStep==="soul_body"){
    window.var_BG_COLOR = '#6e0781';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#bc34e3";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#6e0781";
    window.var_TEXT_VAR = "Breathe health!";
    window.var_LONG_TEXT_1 = "Take care of your body and pay attention to your inner-self, while trying to make";
    window.var_LONG_TEXT_2 = "some space for your soul and well-being. Having respect for yourself physically is";
    window.var_LONG_TEXT_3 = "the main foundation in order to stay healthy and live a happier life.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="soul_planet"){
    window.var_BG_COLOR = '#008a9a';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#42d9f3";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#008a9a";
    window.var_TEXT_VAR = "Breathe intuition!";
    window.var_LONG_TEXT_1 = "What you need the most at this moment is to pay attention to your inner-self";
    window.var_LONG_TEXT_2 = "and express gratitude. You'll be surprised to see how easier and simpler life";
    window.var_LONG_TEXT_3 = "can be when you listen to your intuition, the voice of truth.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="body_planet"){
    window.var_BG_COLOR = '#aa8800';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#f9d942";
    window.var_REFLECTION_SIDE_COLOR = "#999";
    window.var_DARK_SIDE_COLOR = "#aa8800";
    window.var_TEXT_VAR = "Breathe mindfulness!";
    window.var_LONG_TEXT_1 = "Take care of your body and express gratitude for having the chance to live on";
    window.var_LONG_TEXT_2 = "such a beautiful planet. Having respect for yourself physically and your planet";
    window.var_LONG_TEXT_3 = "is the main foundation in order to live a happy and harmonious life.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="good"){
    window.var_BG_COLOR = '#888b8e';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#bdc0c5";
    window.var_REFLECTION_SIDE_COLOR = "#bdc0c5";
    window.var_DARK_SIDE_COLOR = "#888b8e";
    window.var_TEXT_VAR = "You're listenin'!";
    window.var_LONG_TEXT_1 = "Your inner voice is whispering and you hear it, but you need to pay a";
    window.var_LONG_TEXT_2 = "little bit more attention to your inner-self, take care of your body and";
    window.var_LONG_TEXT_3 = "express gratitude to your planet for being alive.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="medium"){
    window.var_BG_COLOR = '#646669';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#b2b5ba";
    window.var_REFLECTION_SIDE_COLOR = "#b2b5ba";
    window.var_DARK_SIDE_COLOR = "#646669";
    window.var_TEXT_VAR = "You're trying to listen!";
    window.var_LONG_TEXT_1 = "Your inner voice is speaking to you, but you almost can't hear it. Pay attention";
    window.var_LONG_TEXT_2 = "to your inner-self, take care of your body and express gratitude for being alive.";
    window.var_LONG_TEXT_3 = "It's never too late to go towards the light.";
    window.var_LONG_TEXT_4 = "";
}

if(window.lastStep==="wrong"){
    window.var_BG_COLOR = '#48494b';
    window.var_TITLE_COLOR = "#fff";
    window.var_CLICKHERE_COLOR = "#9d9fa3";
    window.var_REFLECTION_SIDE_COLOR = "#9d9fa3";
    window.var_DARK_SIDE_COLOR = "#48494b";
    window.var_TEXT_VAR = "You're not listenin'!";
    window.var_LONG_TEXT_1 = "Your inner voice is screaming, but you don't hear it. Don't be surprised";
    window.var_LONG_TEXT_2 = "when you find out that you've been walking on the wrong path all this time.";
    window.var_LONG_TEXT_3 = "You can still find the light in you, it's never too late.";
    window.var_LONG_TEXT_4 = "";
}

const textProps = {
  fontSize: 1.9,
  font: 'https://somati.life/fonts/Playlist-Script.otf'
}

const textProps2 = {
  fontSize: 3,
  font: 'https://somati.life/fonts/Roboto-Medium.ttf'
}

const textProps3 = {
  fontSize: 0.4,
  font: 'https://somati.life/fonts/Roboto-Regular.ttf'
}

const BG_COLOR = window.var_BG_COLOR
const TITLE_COLOR = window.var_TITLE_COLOR
const CLICKHERE_COLOR = window.var_CLICKHERE_COLOR
const REFLECTION_SIDE_COLOR = window.var_REFLECTION_SIDE_COLOR
const DARK_SIDE_COLOR = window.var_DARK_SIDE_COLOR
const TEXT_VAR = window.var_TEXT_VAR
const LONG_TEXT_1 = window.var_LONG_TEXT_1
const LONG_TEXT_2 = window.var_LONG_TEXT_2
const LONG_TEXT_3 = window.var_LONG_TEXT_3
const LONG_TEXT_4 = window.var_LONG_TEXT_4

function Title({ layers, label = '', color = 0xffffff, ...props }) {
  const group = useRef()

  useEffect(() => {
    group.current.lookAt(0, 0, 0)
  }, [])

  return (
    <group {...props} ref={group}>
      <Text castShadow name={label} depthTest={false} material-toneMapped={false} {...textProps} layers={layers}>
        {label}
        <meshBasicMaterial color={color} />
      </Text>
    </group>
  )
}

function Title2({ layers, label = '', color = 0xffffff, ...props }) {
  const group = useRef()

  useEffect(() => {
    group.current.lookAt(0, 0, 0)
  }, [])

  return (
    <group {...props} ref={group}>
      <Text castShadow name={label} depthTest={false} material-toneMapped={false} {...textProps2} layers={layers}>
        {label}
        <meshBasicMaterial color={color} />
      </Text>
    </group>
  )
}

function Title3({ layers, label = '', color = 0xffffff, ...props }) {
  const group = useRef()

  useEffect(() => {
    group.current.lookAt(0, 0, 0)
  }, [])

  return (
    <group {...props} ref={group}>
      <Text castShadow name={label} depthTest={false} material-toneMapped={false} {...textProps3} layers={layers}>
        {label}
        <meshBasicMaterial color={color} />
      </Text>
    </group>
  )
}

function TitleCopies({ layers, label, color, ...props }) {
  const vertices = useMemo(() => {
    const y = new THREE.CircleGeometry(10, 4, 4)
    return y.vertices
  }, [])

  return (
    <group name="titleCopies" {...props}>
      {vertices.map((vertex, i) => (
        <Title name={'titleCopy-' + i} label={label} position={vertex} layers={layers} color={color} />
      ))}
    </group>
  )
}

var clickCounter = 0
window.buttonNext_Active = false

function nextBTN_Init() {
    clickCounter++
    if(clickCounter >= 6 && !(window.buttonNext_Active)){
        window.buttonNext_Active = true
    }
}

function PhysicalWalls(props) {
  usePlane(() => ({ ...props }))

  // back wall
  usePlane(() => ({ position: [0, 100, -15] }))

  return (
    <Plane args={[1000, 1000]} {...props} receiveShadow>
      <shadowMaterial transparent opacity={0.3} />
    </Plane>
  )
}

function PhysicalTitle(props) {
  useBox(() => ({ ...props }))
  return null
}

function Mirror({ sideMaterial, reflectionMaterial, ...props }) {
  const [ref, api] = useBox(() => props)

  return (
    <Box
      ref={ref}
      args={props.args}
      onClick={() => {
          api.applyImpulse([0, -5, -90], [0, 0, 0]);
          nextBTN_Init();
      }}
      receiveShadow
      castShadow
      material={[sideMaterial, sideMaterial, sideMaterial, sideMaterial, reflectionMaterial, sideMaterial]}
    />
  )
}

function Mirrors({ envMap }) {
  const ROWS = 3
  const COLS = 10
  const BOX_SIZE = 1.5

  const sideMaterial = useResource()
  const reflectionMaterial = useResource()

  const mirrorsData = useMemo(
    () =>
      new Array(ROWS * COLS).fill().map((_, index) => ({
        mass: 1.7,
        material: { friction: 3, restitution: 0 },
        args: [BOX_SIZE, BOX_SIZE, BOX_SIZE],
        position: [
          -COLS + ((index * BOX_SIZE) % (BOX_SIZE * COLS)) + 2.5,
          -1 + BOX_SIZE * Math.floor((index * BOX_SIZE) / (BOX_SIZE * COLS)),
          0
        ]
      })),
    []
  )

  return (
    <>
      <meshPhysicalMaterial ref={sideMaterial} color={DARK_SIDE_COLOR} envMap={envMap} roughness={0.3} metalness={0.4} />
      <meshPhysicalMaterial ref={reflectionMaterial} envMap={envMap} roughness={0} metalness={1} color={REFLECTION_SIDE_COLOR} />
      <group name="mirrors">
        {mirrorsData.map((mirror, index) => (
          <Mirror
            key={`0${index}`}
            name={`mirror-${index}`}
            {...mirror}
            sideMaterial={sideMaterial.current}
            reflectionMaterial={reflectionMaterial.current}
          />
        ))}
      </group>
    </>
  )
}

function Background({ layers, ...props }) {
  const ref = useLayers(layers)
  return (
    <Octahedron ref={ref} name="background" args={[100]} {...props}>
      <meshBasicMaterial color={BG_COLOR} side={THREE.BackSide} />
    </Octahedron>
  )
}

export default function Scene() {
  const group = useSlerp()
  const [cubeCamera, renderTarget] = useRenderTarget()

  return (
    <>
      <group name="sceneContainer" ref={group}>
        <Background layers={[0, 11]} position={[0, 0, -5]} />
        <cubeCamera
          layers={[11]}
          name="cubeCamera"
          ref={cubeCamera}
          position={[0, 0, 0]}
          args={[0.1, 400, renderTarget]}
        />

        <Title name="title" label={TEXT_VAR} position={[0, 4, -5]} color={TITLE_COLOR} />
        <TitleCopies position={[0, 2, -5]} rotation={[0, 0, 0]} layers={[11]} label={TEXT_VAR} color={TITLE_COLOR} />
        <Title3 name="title" label={LONG_TEXT_1} position={[0, 2.2, -6]} color={TITLE_COLOR} />
        <Title3 name="title" label={LONG_TEXT_2} position={[0, 1.6, -6]} color={TITLE_COLOR} />
        <Title3 name="title" label={LONG_TEXT_3} position={[0, 1.0, -6]} color={TITLE_COLOR} />
        <Title3 name="title" label={LONG_TEXT_4} position={[0, 0.4, -6]} color={TITLE_COLOR} />

        <Title2 layers={[11]} name="title" label="BREAK YOUR BARRIER!" position={[0, 3, 24]} scale={[-1, 1, 1]} color={CLICKHERE_COLOR} />
        <Title2 layers={[11]} name="title" label="Click / Tap here to" position={[0, 14, 52]} scale={[-1, 1, 1]} color={CLICKHERE_COLOR} />

        <Physics gravity={[0, -17, 0]}>
          <Mirrors envMap={renderTarget.texture} />
          <PhysicalWalls rotation={[-Math.PI / 2, 0, 0]} position={[0, -2, 0]} />
          <PhysicalTitle args={[13, 2.5, 0.1]} position={[0, 2.25, -10]} />
        </Physics>
      </group>

      <pointLight
        castShadow
        position={[0, 10, 6]}
        intensity={4.5}
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
        shadow-camera-far={150}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      />
    </>
  )
}